import { render } from "./ContractUpdate.vue?vue&type=template&id=3185031d&scoped=true"
import script from "./ContractUpdate.vue?vue&type=script&lang=js"
export * from "./ContractUpdate.vue?vue&type=script&lang=js"

import "./ContractUpdate.vue?vue&type=style&index=0&id=3185031d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3185031d"]])

export default __exports__